import _ from 'lodash'
import qs from 'qs'
import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, challengeId, params) {
    const url = `/api/v1/organizations/${organizationId}/challenges/${challengeId}`
    return HTTP.get(url, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  getRevs(organizationId, challengeId, params) {
    const url = `/api/v1/organizations/${organizationId}/challenges/${challengeId}/revs`
    return HTTP.get(url, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/challenges`
    return HTTP.post(url, data)
  },

  update(organizationId, challengeId, data) {
    const url = `/api/v1/organizations/${organizationId}/challenges/${challengeId}`
    return HTTP.patch(url, data)
  },

  remove(organizationId, challengeId) {
    const url = `/api/v1/organizations/${organizationId}/challenges/${challengeId}`
    return HTTP.delete(url)
  },

  share(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/shares`
    const { sharedBy, sharedTo, message, sharedObjectId } = payload

    return HTTP.post(url, {
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
      sharedObjectType: 'Challenge',
    })
  },

  getChallengesFromRev(revType, organizationId, revId) {
    const formattedRevType = _.kebabCase(revType)
    const url = `/api/v1/organizations/${organizationId}/${formattedRevType}/${revId}/challenges`
    return HTTP.get(url)
  },

  linkChallengeToRev(organizationId, revType, revId, challengeId) {
    const formattedRevType = formatRevType(revType)

    const url = `/api/v1/organizations/${organizationId}/${formattedRevType}/${revId}/challenges/${challengeId}`
    return HTTP.post(url)
  },

  removeChallengeFromRev(organizationId, revType, revId) {
    const formattedRevType = _.kebabCase(revType)
    const url = `/api/v1/organizations/${organizationId}/${formattedRevType}/${revId}/challenges`
    return HTTP.delete(url)
  },
}

function formatRevType(type) {
  switch (type) {
    case 'improvementIdea':
      return 'revs'
    case 'quickAction':
      return 'quick-actions'
    case 'problemSolving':
      return 'problem-solving'
    default:
      return _.kebabCase(type)
  }
}
